import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface PageConfigCardProps {
  title: string;
  children: ReactNode;
}

export const PageConfigCard = ({ title, children }: PageConfigCardProps) => (
  <Box
    sx={{
      bgcolor: "grey.50",
      border: "1px solid",
      borderColor: "grey.300",
      borderRadius: 2,
      p: 2,
    }}
  >
    <Typography
      component="div"
      sx={{
        fontSize: "0.8rem",
        fontWeight: 600,
        color: "grey.700",
        mb: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          bgcolor: "primary.main",
          borderRadius: "50%",
        }}
      />
      {title}
    </Typography>
    {children}
  </Box>
);
